import { combineReducers } from 'redux';
import langConfig from '@nykaa/intl-shared/store/reducer';
import appReducer from './app/reducer';
import navigation from './Navigation/reducer';
import dataLayer from './dataLayer/reducer';
import product from './product/reducer';
import auth from './auth/reducer';
import searchSuggestions from './searchSuggestions/reducer';
import reviewImages from './review/reducer';
import remoteConfig from './remoteConfig/reducer';
import newBuyersSkuConfig from './newBuyersSkuConfig/reducer';
import productQna from './productQNA/reducer';
import variants from './variants/reducer';
import priceReveal from '@nykaa/prices-revealed-shared/store/reducer';
import jsonLdData from '@nykaa/jsonld-shared/store/reducer';
import homeReducer from './home/reducer';
import fitcode from './fitcode/reducer';
import categoryListing from './categoryListing/reducer';
import footerReducer from './footer/reducer';
import searchListing from './searchListing/reducer';
import pro from './pro/reducer';
import VP from './visitorPrioritization/reducer';
import getReviews from './allReview/reducer';
import cmsReducer from './cms/reducer';
import abExperiments from '@nykaa/experiment-sdk/store/reducer';
import shareAndEarn from '@nykaa/product-image/store/reducer';
import loyaltyReducer from '@nykaa/prive-shared/store/reducer';
import videoConsultation from '@nykaa/video-consultation-shared/store/reducer';
import proUserInfo from '@nykaa/pro-registration/store/reducer';
import myProfile from '@nykaa/my-profile-shared/store/reducer';
import couponReducer from './coupons/reducer';
import RecommendationsList from '@nykaa/reco-widget-shared/store/reducer';
import PredictAndWin from '@nykaa/predict-and-win-shared/store/reducer';
import wishlistReducer from '@nykaa/wishlist-shared/store/reducer';
import { default as priveCouponReducer } from '@nykaa/coupon-shared/store/reducer';
import authReducer from '@nykaa/auth-shared/store/reducers';
import footerPopularLinksConfig from './footerPopularLinks';
import dpMetaData from '@nykaa/seo/store/reducer';
import beautyPortfolio from '@nykaa/beauty-portfolio-shared/store/reducer';
import bestSellerPage from '@nykaa/listing-shared/bestseller/store/reducer';
import gamesConfig from '@nykaa/cp-games-shared/store/reducer';
import reviewAllImages from '@nykaa/review-all-images-shared/store/reducer';
import productsFromBulkService from '@nykaa/product-shared/store/reducer';
import delivery from '@nykaa/delivery-shared/store/reducer';
import cartReducer from '@nykaa/cart-shared/store/reducer';

const createRootReducer = () =>
  combineReducers({
    appReducer,
    auth,
    dataLayer,
    productPage: product,
    searchSuggestions,
    reviewImages,
    navigation,
    remoteConfig,
    newBuyersSkuConfig,
    productQna,
    variants,
    priceReveal,
    jsonLdData,
    homePage: homeReducer,
    fitcode,
    categoryListing,
    footer: footerReducer,
    searchListingPage: searchListing,
    pro,
    VP,
    getReviews,
    langConfig,
    cmsReducer,
    abExperiments,
    proUserInfo,
    loyaltyReducer,
    shareAndEarn,
    videoConsultation,
    myProfile,
    couponReducer,
    RecommendationsList,
    PredictAndWin,
    wishlistReducer,
    priveCouponReducer,
    authReducer,
    footerPopularLinksConfig,
    dpMetaData,
    beautyPortfolio,
    bestSellerPage,
    gamesConfig,
    reviewAllImages,
    productsFromBulkService,
    delivery,
    cartReducer,
  });

export default createRootReducer;
